module.exports = __webpack_public_path__ + "media/pages/faq-b9bcfeed.jpeg";